import { X, Calendar, Eye } from "lucide-react";
import { Badge, cover, fmtDate } from "./HomeBlocks";
import Avatar from "@/components/Avatar";

export default function NewsModal({ news, onClose }) {
  if (!news) return null;
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 grid place-items-center p-4" onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <article className="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="news-modal">
        {cover(news.cover_url) && <img src={cover(news.cover_url)} alt="" className="w-full aspect-[16/8] object-cover"/>}
        <div className="p-6">
          <div className="flex items-start justify-between gap-3">
            <div>{news.category && <Badge label={news.category}/>}</div>
            <button onClick={onClose} data-testid="news-modal-close" className="p-1 rounded-md hover:bg-slate-100"><X className="w-4 h-4"/></button>
          </div>
          <h2 className="mt-2 text-2xl font-bold text-[#0b1b3a] leading-tight">{news.title}</h2>
          {news.summary && <p className="mt-2 text-base text-slate-600 italic">{news.summary}</p>}
          <div className="mt-3 flex items-center gap-3 text-xs text-slate-400">
            {news.author_name && <span className="flex items-center gap-1.5"><Avatar user={{ name: news.author_name, avatar_url: news.author_avatar }} size={20}/>{news.author_name}</span>}
            <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5"/>{fmtDate(news.created_at)}</span>
            <span className="flex items-center gap-1"><Eye className="w-3.5 h-3.5"/>{news.views || 0} vues</span>
          </div>
          {news.body && <div className="mt-5 text-sm text-slate-700 leading-relaxed whitespace-pre-line">{news.body}</div>}
          {news.link && <a href={news.link} className="inline-block mt-5 text-sm font-semibold text-[#1d4ed8] hover:underline">En savoir plus →</a>}
        </div>
      </article>
    </div>
  );
}
